import React from 'react'

export default function Footer() {
  return (
    <div>
        <footer className="pt-4 my-md-5 pt-md-5 border-top">
                <div className="row">
                <div className="col-12 col-md">
                    <small className="d-block mb-3 text-muted">©Panorama 2024</small>
                    <ul className="list-unstyled">
                    <li><a href="#">Privacy</a>
                    <a href="#">Terms</a>
                    <a href="#">Support</a></li>
                    </ul>
                    <div className='contact_icons'>
              <a href="#" className="text-muted me-3"><i className="fab fa-facebook fa-lg"></i></a>
              <a href="#" className="text-muted me-3"><i className="fab fa-linkedin fa-lg"></i></a>
              <a href="#" className="text-muted me-3"><i className="fab fa-youtube fa-lg"></i></a>
              <a href="#" className="text-muted"><i className="fab fa-instagram fa-lg"></i></a>
            </div>
                </div>
                <div className="col-6 col-md">
                    <h5>Topic</h5>
                    <ul className="list-unstyled text-small">
                    <li><a className="text-muted" href="#">Products</a></li>
                    <li><a className="text-muted" href="#">News</a></li>
                    <li><a className="text-muted" href="#">Media</a></li>
                    </ul>
                </div>
                <div className="col-6 col-md">
                    <h5>Topic</h5>
                    <ul className="list-unstyled text-small">
                    <li><a className="text-muted" href="#">Resources</a></li>
                    <li><a className="text-muted" href="#">Technical support</a></li>
                    <li><a className="text-muted" href="#">Purchasing</a></li>
                    </ul>
                </div>
                <div className="col-6 col-md">
                    <h5>Topic</h5>
                    <ul className="list-unstyled text-small">
                    <li><a className="text-muted" href="#">Learn</a></li>
                    <li><a className="text-muted" href="#">Partners</a></li>
                    <li><a className="text-muted" href="#">Training & certification</a></li>
                    </ul>
                </div>
                </div>
            </footer>
    </div>
  )
}
